/**
 * Dashboard page constants.
 * Single source of truth: storage keys, default names, step-to-route mapping.
 */

import ROUTES from '../../../constants/routes';

export const ORGANIZATION_NAME_STORAGE_KEY = 'organizationName';
export const ORGANIZATION_ID_STORAGE_KEY = 'organizationId';
export const DEFAULT_ORGANIZATION_NAME = 'Organization';

/** Step number -> route for wizard navigation (Open/Closed: add steps here) */
export const STEP_ROUTES = {
  1: ROUTES.SET_ORGANIZATION_STRUCTURE,
  2: ROUTES.INVITE_USERS,
  3: ROUTES.SET_CLEANING_STANDARDS,
};

/**
 * Get organization ID from state (auth user may have organization or organizationId).
 * @param {Object} state - Redux state
 * @returns {string|null}
 */
export function getOrganizationIdFromState(state) {
  const user = state?.auth?.user;
  return user?.organization ?? user?.organizationId ?? user?.data?.organization ?? user?.data?.organizationId ?? null;
}

/**
 * Get organization name from storage or default.
 * @returns {string}
 */
export function getOrganizationName() {
  return (
    localStorage.getItem(ORGANIZATION_NAME_STORAGE_KEY) || DEFAULT_ORGANIZATION_NAME
  );
}
